/** DVA namespace — must match `model.js`. */
export const MODEL_NAME = 'customerDiscounts';

export const API_ROUTE = 'billing/customer-discounts';

export const PAYMENTS_HISTORY_ROUTE = 'billing/subscription-payments';

/** i18n resource key for the form drawer hero. */
export const FORM_RESOURCE_KEY = 'customerDiscounts';
